module.exports = __webpack_public_path__ + "img/login.e36dd302.svg";